import React from "react";
import { useGlobalContext } from "context/global";
import clsx from "clsx/lite";

const CartBox = ({ box, isDisabled, isActive, showError, hideError, handleClick }) => {
	const { cartSettings: { boxes } } = useGlobalContext();
	const width = isActive ? `${(100 / boxes.length) - 2}%` : `${100 / boxes.length}%`;

	return (
		<button
			onMouseOver={() => isDisabled && showError()}
			onMouseLeave={() => hideError()}
			onClick={() => !isDisabled && handleClick(box)}
			style={{ width }}
			className={clsx("pb-0.5 pt-1.5 text-sm ",
				isDisabled ? "border-tertiary text-secondary cursor-auto" : "border-black",
				isActive && "bg-white first:ml-1 last:mr-1 rounded-6xl my-1"
			)}
		>
			{box.size.name}
		</button>
	);
};


export default CartBox;